// extracted by mini-css-extract-plugin
export default {"overlay":"MealActions_overlay__-TUNW","mainButton":"MealActions_mainButton__uEs-b","actions":"MealActions_actions__8fRG9","actionButton":"MealActions_actionButton__hqPb-"};